import apiClient from "config/apiClient";
import Notify from "config/notify";
import { PaginationParamType } from "type";
import {
  TUploadImageType,
  WheelBrand,
  WheelBrandDetailSelectResponse,
  WheelBrandDetailUpdateRequest
} from "../types/wheel-brand";

/**
 * Fetches the details of wheel brands.
 * @returns {Promise<WheelBrand[]>} A promise that resolves to an array of wheel brands.
 */
export const getWheelDetails = async (
  params: PaginationParamType,
): Promise<WheelBrandDetailSelectResponse | undefined> => {
  const res = await apiClient.post<WheelBrandDetailSelectResponse>(
    "/mst/item/brand/detail/wheel/select",
    params,
  );
  return res.data;
};

/**
 * Updates the details of a wheel brand.
 * @param {WheelBrandDetailUpdateRequest} data - The data to update the wheel brand details.
 * @returns {Promise<void>} A promise that resolves when the update is complete.
 */
export const updateWheelDetails = async (data: WheelBrandDetailUpdateRequest): Promise<void> => {
  const response = await apiClient.post("/mst/item/brand/detail/wheel/update", data);
  if (response.status === 200) {
    // Notify.setNotification({
    //   show: true,
    //   title: "更新が完了しました",
    //   confirmLabel: "OK",
    //   actionsPosition: "end",
    // });
    return;
  }
  throw new Error(response.message);
};

/**
 * Deletes the image of a wheel brand.
 * @param {string} brandCd - The brand code of the wheel.
 * @returns {Promise<void>} A promise that resolves when the image is deleted.
 */
export const deleteBrandWheelImage = async (
  brandCd: string,
  type: TUploadImageType,
  color?: string,
  hole?: string,
): Promise<void> => {
  const response = await apiClient.post("/mst/item/brand/detail/wheel/delete/image", {
    brand_cd: brandCd,
    type,
    color,
    hole,
  });
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "削除が完了しました。",
      confirmLabel: "OK",
      actionsPosition: "center",
    });
  }
};

/**
 * Uploads an image for a wheel brand.
 * @param {string} brandCd - The brand code of the wheel.
 * @param {File} file - The image file to upload.
 * @param {TUploadImageType} type - The type of image being uploaded.
 * @param {string} [color] - Optional color parameter.
 * @param {string} [hole] - Optional hole parameter.
 * @returns {Promise<any>} A promise that resolves with the response from the API.
 */
export const uploadBrandWheelImage = async (
  brandCd: string,
  file: File,
  type: TUploadImageType,
  color?: string,
  hole?: string,
): Promise<any> => {
  const formData = new FormData();
  formData.append("brand_cd", brandCd);
  formData.append("image_file", file);
  formData.append("type", type);
  if (color) formData.append("color", color);
  if (hole) formData.append("hole", hole);

  const response = await apiClient.post("/mst/item/brand/detail/wheel/upload/image", formData, {
    "Content-Type": "multipart/form-data",
  });
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "アップロードが完了しました。",
      confirmLabel: "OK",
      actionsPosition: "center",
    });
  }
  return response;
};
